LS.util.route({
	'support': {
		'$index': {
			':load': 'support',
			':unload': 'support:unload'
		}
	}
});